import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const ExecutiveConversations = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage
        tagName="p"
        {...messages.executiveConversationsBody}
      />
    </ArticleBody>
  </div>
);

ExecutiveConversations.propTypes = {};

export default ExecutiveConversations;
